export  default {
    setCustomer(state, payload) {
        state.customer = payload;
      },
};